import styled from "styled-components";
import { PolicyDataContainer } from "../../../health/forms/policy-data/policy-data-style";

export const HealthForeignersPolicyContainer = styled(PolicyDataContainer)``;
